import { Page, Text, View, Document, Image } from "@react-pdf/renderer";
import { Font, StyleSheet } from "@react-pdf/renderer";
import { handleArabicPunctuation } from "../../function";

Font.register({
  family: "IBM Plex Sans Arabic",
  src: "/fonts/IBMPlexSansArabic/IBMPlexSansArabic-Regular.ttf",
});
Font.register({
  family: "IBM Plex Sans Arabic Bold",
  src: "/fonts/IBMPlexSansArabic/IBMPlexSansArabic-Bold.ttf",
});

export const Styles = StyleSheet.create({
  portraitPage: {
    fontFamily: "IBM Plex Sans Arabic",
    fontSize: "9px",
    padding: "57px 17px",
    flexDirection: "row",
    lineHeight: "1.7",
  },
  portraitTopSectionText: {
    height: "50%",
    textAlign: "right",
    width: "100%",
    marginBottom: "30px",
    lineHeight: "1.7",
  },
  portraitBottomSectionText: {
    height: "50%",
    transform: "rotate(180deg)",
  },
  landscapePage: {
    fontFamily: "IBM Plex Sans Arabic",
    fontSize: "9px",
    width: "100%",
    flexDirection: "row",
  },
  landscapeLeft: {
    flexDirection: "row",
    padding: "57px 17px",
    width: "50%",
  },
  landscapeRight: {
    flexDirection: "row",
    padding: "57px 17px",
    width: "50%",
  },
  arrowIcon: {
    width: "12px",
    height: "7px",
  },
  curveArrowIcon: {
    width: "15px",
    height: "15px",
  },
  arrowIconCont: {
    fontSize: "6px",
    color: "#FF0000",
  },
  pointingText: {
    fontFamily: "IBM Plex Sans Arabic Bold",
    marginBottom: "6px",
  },
  flexRowReverse: {
    flexDirection: "row-reverse",
  },
  flexWrap: {
    flexWrap: "nowrap",
  },
  ml1: {
    marginLeft: "2pt",
  },
});

const MyDocument16 = ({ arabChunks, engChunks }) => {
  const arabicText = (arabicChunks) => {
    return (
      // iterate over the text divided in lines
      arabicChunks?.map((line, idx) => {
        return (
          <View style={[Styles.flexRowReverse, Styles.flexWrap, {}]} key={idx}>
            {
              // divide every line into words and arrange them RTL
              line.map((word, idxWord) => {
                // correct every word for paired punctuation
                return handleArabicPunctuation(word).map(
                  (punctuationWord, punctuationIdx) => {
                    return (
                      <Text style={Styles.ml1} key={punctuationIdx}>
                        {punctuationWord}
                      </Text>
                    );
                  }
                );
              })
            }
          </View>
        );
      })
    );
  };
  let landscapePagesArray = [];
  const landscapePages = () => {
    let a = 2;
    for (let i = 1; i < 4; i++) {
      landscapePagesArray.push(
        <>
          <View style={Styles.landscapeLeft}>
            <View style={{ width: "40px", marginRight: "6px" }}></View>
            <View style={{ width: "80%" }}>
              <View
                style={[
                  {
                    height: "225px",
                    overflow: "hidden",
                    textAlign: "right",
                    marginBottom: "30px",
                  },
                ]}
              >
                {arabicText(arabChunks[a])}
              </View>
              <View
                style={{
                  height: "225px",
                  overflow: "hidden",
                  transform: "rotate(180deg)",
                }}
              >
                {engChunks[a]?.map((word, idx) => {
                  return (
                    <Text style={{}} key={idx}>
                      {word}
                    </Text>
                  );
                })}
              </View>
            </View>
            <View style={{ width: "40px", marginLeft: "6px" }}>
              <View>
                <Image
                  src="/images/leftpdf_arrow.png"
                  style={Styles.arrowIcon}
                ></Image>
              </View>
              <View style={{ position: "absolute", top: "98%" }}>
                <Image
                  src="/images/leftpdf_arrow.png"
                  style={Styles.arrowIcon}
                ></Image>
              </View>
            </View>
          </View>
          <View style={Styles.landscapeRight}>
            <View style={{ width: "40px", marginRight: "6px" }}></View>
            <View style={{ width: "80%" }}>
              <View
                style={[
                  {
                    height: "225px",
                    overflow: "hidden",
                    textAlign: "right",
                    marginBottom: "30px",
                  },
                ]}
              >
                {arabicText(arabChunks[a - 1])}
              </View>
              <View
                style={{
                  height: "225px",
                  overflow: "hidden",
                  transform: "rotate(180deg)",
                }}
              >
                {engChunks[a - 1]?.map((word, idx) => {
                  return (
                    <Text style={{}} key={idx}>
                      {word}
                    </Text>
                  );
                })}
              </View>
            </View>
            <View style={{ width: "40px", marginLeft: "6px" }}>
              <View>
                <Image
                  src="/images/leftcurvepdf_arrow.png"
                  style={[Styles.curveArrowIcon, { marginTop: "-5px" }]}
                ></Image>
              </View>
              <View
                style={{
                  position: "absolute",
                  top: "98%",
                  transform: "rotate(180deg)",
                }}
              >
                <Image
                  src="/images/rightcurvepdf_arrow.png"
                  style={[Styles.curveArrowIcon, { width: "20px" }]}
                ></Image>
              </View>
            </View>
          </View>
        </>
      );
      a += 2;
    }
  };
  landscapePages();
  return (
    <Document>
      <Page size="A5" style={Styles.portraitPage}>
        <View style={{ width: "40px" }}></View>
        <View style={{ width: "80%" }}>
          <View style={[Styles.portraitTopSectionText]}>
            {arabicText(arabChunks[0])}
          </View>

          <View style={Styles.portraitBottomSectionText}>
            {engChunks[0]?.map((word, idx) => {
              return (
                <Text style={{}} key={idx}>
                  {word}
                </Text>
              );
            })}
          </View>
        </View>
        <View style={{ width: "40px", marginLeft: "6px" }}>
          <View style={Styles.arrowIconCont}>
            <Text style={[Styles.pointingText, { marginTop: "-13px" }]}>
              بداية النص
            </Text>
            <Image
              src="/images/leftpdf_arrow.png"
              style={Styles.arrowIcon}
            ></Image>
          </View>
          <View
            style={[
              Styles.arrowIconCont,
              {
                position: "absolute",
                top: "98%",
                transform: "rotate(180deg)",
              },
            ]}
          >
            <Text style={Styles.pointingText}>Start of text</Text>
            <Image
              src="/images/rightpdf_arrow.png"
              style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
            ></Image>
          </View>
        </View>
      </Page>

      {landscapePagesArray.map((array, index) => {
        return (
          <Page
            size="A4"
            style={Styles.landscapePage}
            orientation="landscape"
            key={index}
          >
            {array}
          </Page>
        );
      })}

      <Page size="A5" style={Styles.portraitPage}>
        <View style={{ width: "40px" }}>
          <View
            style={[Styles.arrowIconCont, { position: "absolute", top: "40%" }]}
          >
            <Text style={Styles.pointingText}>نهاية النص</Text>
            <Image
              src="/images/rightpdf_arrow.png"
              style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
            ></Image>
          </View>
          <View
            style={[
              Styles.arrowIconCont,
              { position: "absolute", top: "52%", transform: "rotate(180deg)" },
            ]}
          >
            <Text style={Styles.pointingText}>End of text</Text>
            <Image
              src="/images/leftpdf_arrow.png"
              style={Styles.arrowIcon}
            ></Image>
          </View>
        </View>
        <View style={{ width: "80%" }}>
          <View style={[Styles.portraitTopSectionText]}>
            {arabicText(arabChunks[7])}
          </View>
          <View style={Styles.portraitBottomSectionText}>
            {engChunks[7]?.map((word, idx) => {
              return (
                <Text style={{}} key={idx}>
                  {word}
                </Text>
              );
            })}
          </View>
        </View>
        <View style={{ width: "40px", marginLeft: "6px" }}>
          <View>
            <Image
              src="/images/leftpdf_arrow.png"
              style={Styles.arrowIcon}
            ></Image>
          </View>
          <View style={{ position: "absolute", top: "98%" }}>
            <Image
              src="/images/leftpdf_arrow.png"
              style={Styles.arrowIcon}
            ></Image>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default MyDocument16;
